<template>
  <div
    class="mc-fix-alert z-2002"
    v-if="show && $ls.get('maintanace') != version"
  >
    <b-row align-v="center">
      <b-col>
        <b-media no-body class="mr-4">
          <!-- <b-media-aside vertical-align="center" class="mr-3">
            <img src="@/assets/img/icons/bell-yellow.svg" width="24" alt="" />
          </b-media-aside> -->
          <b-media-body>
            <span class="font-15">
              Some of our clients are currently experiencing difficulties -
              accessing certain features.<br />
              Our team is actively working to resolve the issue as quickly as
              possible.
            </span>
          </b-media-body>
        </b-media>
      </b-col>
      <!--<b-col md="auto" class="ml-md-auto">-->
      <!--  <b-button-->
      <!--    variant="primary"-->
      <!--    size="sm"-->
      <!--    class="mx-md-5 mt-2 mt-md-0"-->
      <!--    @click="close"-->
      <!--  >-->
      <!--    Try now-->
      <!--  </b-button>-->
      <!--</b-col>-->
    </b-row>
    <button type="button" class="close" aria-label="Close" @click="close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
// import { automationAllowedLimit } from "@/functions/automation.js";
export default {
  components: {},
  data() {
    return {
      // show: !!automationAllowedLimit(),
      show: false,
      version: "15",
    };
  },
  methods: {
    close() {
      this.show = false;
      this.$ls.set("maintanace", this.version);
    },
  },
};
</script>
